import { TextField } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { useFormData } from "@totalenergiescode/mobility-business-rev-form-data/components";
import { type ChangeEvent, useCallback } from "react";

export interface SimpleInputProps {
  fieldId: string;
}

const SimpleInput = (props: SimpleInputProps) => {
  const findFieldById = useFormData((fd) => fd.findFieldById);

  const field = findFieldById(props.fieldId);
  const value = field.value.asString();

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      field.setValue(e.target.value);
    },
    [field],
  );

  const errorMessage = field.violations().join(", ");
  const customName = field.id();
  const writable = field.writable;

  const { translatorFor } = useFormDataContext();

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);

  return (
    <>
      <TextField
        type='text'
        errorText={errorMessage || ""}
        helperText={""}
        isError={Boolean(errorMessage)}
        required={Boolean(field.required)}
        label={`${label}`}
        value={value.hasBeenSet() ? value.value() : value.defaultValue()}
        onChange={onChange}
        disabled={!writable}
        key={field.id()}
        dataTestId={`ledgers-order__textfield-${customName}`}
      />
    </>
  );
};

export default SimpleInput;
